import React, { Fragment, useEffect, useRef, useState } from 'react';
import {
    setAppCustomTitle
} from "../../reducers/ThemeOptions";
import { connect } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import Common from '../Common';
import Select from "react-select";
import back_icon from "../Conversations/assets/images/back_icon.svg";
import { getReferenceList, getSessionValue,showToast, confirmBox, translateContent,getDeleteIcon, isMobile } from '../../Common/Appcommon';
import requestApi from "../../services/requestApi.service";
import {
    Row,
    Col,
    Container,
    Button,
    Input
} from "reactstrap";
import { deleteMobileDetail, updateMobileDetail } from '../Agents/ProviderDetails';


const PhoneNumberContent = (props) => {
    const { handleSubmit: handleActionFormSubmit, control, formState: { errors }, setError,trigger } = useForm();
    const saveBtnRef = useRef(null);
    let { rowData, backToPN, deletePN, pnLabelMapper, pnFormDetails } = props;
    let [pnFormData, setPnFormData] = useState(rowData);
    let [defaultDpDown, setDefaultDpDown] = useState(null);
    let [agentDpDown, setAgentDpDown] = useState([]);
    let [agentIds,setAgentIds] = useState([])
    let [selectedAgent,setSelectedAgent] = useState("");
    let [showLoader , setShowLoader]  = useState(true);
    let [defaultDpDownOutbound, setDefaultDpDownOutbound] = useState(null);
    let [defaultDpDownInbound, setDefaultDpDownInbound] = useState(null);
    let [selectedAgentOutbound, setSelectedAgentOutbound] = useState("");
    let [selectedAgentInbound, setSelectedAgentInbound] = useState("");

    const proName = getSessionValue("agent_provider_name");
    const issubaccountView = getSessionValue("isSubAccountView");
    useEffect(() => {
        if (rowData && !pnFormData) {
            setPnFormData(rowData);
        }
        (async () => {
            setShowLoader(true);
            await fetchFormDetails();
            await fetchAgencyDetails();
            setShowLoader(false);
        })();
    }, [rowData]);

    const fetchAgencyDetails = async () => {
        let fieldName = pnLabelMapper['table_250_0_table_250_id'];
        let defaultAgent = pnFormData[fieldName + "_id"];
        let fDetail = pnFormDetails[1];

        /*let refDetail = fDetail.filter(record => record[2] === 'table_250_0_table_250_id')[0];
        if(refDetail && refDetail[35] !== undefined){
            let res = await getReferenceList(refDetail[35], defaultAgent);
            if (res?.issuccess) {
                let optionList = res.data;
                setAgentDpDown(optionList[0]);
                let { value, label } = optionList[1];
                if (value && label) {
                    setDefaultDpDown(optionList[1]);
                    setSelectedAgent(agentIds[value]);
                }
            }
        }*/
    }

    const handleAgentChange = (option, type) => {
        const id = option?.value;
        if (type === "outbound") {
            setSelectedAgentOutbound(agentIds[id]);
            setDefaultDpDownOutbound(option);
        } else {
            setSelectedAgentInbound(agentIds[id]);
            setDefaultDpDownInbound(option);
        }
    };

    const saveMobileDetail = async () => {
        if (!(await trigger("Name")) || !(await trigger("agent_id"))) {
            return;
        }
        let data = [];
        let number = "";
        let id = "";
        let name = "";
        let assistantid  = "";
        let res;
        setShowLoader(true);
        let param =  {
            id:pnFormData[pnLabelMapper['Id']],
            name:pnFormData[pnLabelMapper['Name']],
            assistantid:selectedAgent,
            phoneNumber:pnFormData[pnLabelMapper['Phone_Number']],
            inboundAssistantid:selectedAgentInbound,
            outboundAssistantid:selectedAgentOutbound,
            tableId:pnFormData['table_247_id']
        }

        /*if (proName === 'vapi' || (proName === 'retell' && id?.includes('-retell'))) {
            res = await updateMobileDetail(proName, param);
            if (!res.issuccess) {
                return;
            }
        }
        
        if (proName === 'vapi') {
            number = res.data.number;
            id = res.data.id;
            name = res.data.name;
            assistantid = res.data.assistantId;
        }else if(   proName === 'retell'){
            number = pnFormData[pnLabelMapper['Phone_Number']];
            name = pnFormData[pnLabelMapper['Name']];
            id = pnFormData[pnLabelMapper['Id']];
            assistantid = selectedAgent;
        }
        data = {
            phone_number:number ,
            name:name ,
            id: id,
            assistantId: assistantid,
            inboundAssistantid:selectedAgentInbound,
            outboundAssistantid:selectedAgentOutbound,
        };*/
        const reqobj = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "SAVE_PN_DETAILS",
            provider: proName,
            FORMDATA: param,
            providerUpdate:true,
        };
        const response = await requestApi.processServerRequest(reqobj);
        const message = response.issuccess 
            ? translateContent("vm.number.update.succuss")
            : translateContent("vm.number.update.failed");
        const toastType = response.issuccess ? "success" : "error";
        showToast(message, 'top-right', toastType);
        setShowLoader(false);
        if(response.issuccess){
            backToPN();        
        }
    }

    const removeMobileDetail  = async () =>{
        let confirm = await confirmBox(translateContent("vm.delete.confirm"), translateContent("vm.delete.alert.msg") + translateContent("vm.delete.confirm.msg"),getDeleteIcon(),'Delete','Cancel');
        if (!confirm) {
            return;
        }
        setShowLoader(true);
        let data = [];
        let id = pnFormData[pnLabelMapper['Id']];
        let phoneNumber = pnFormData[pnLabelMapper['Phone_Number']];
        let tableId= pnFormData['table_247_id'];
        let param = {
            id:id,
            phoneNumber:phoneNumber,
        }
        /*if(proName === "vapi" || (proName === "retell" && id.includes("-retell"))){
            let res =  await deleteMobileDetail(proName,param);
            if (!res.issuccess && res.statusCode !== 404) {
                return;
            }
        }*/
        data = {
            phone_number:phoneNumber,   
            id: id,
            table_id: tableId,
        };
        let reqobj = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "DELETE_PN_DETAILS",
            provider: proName,
            FORMDATA: data,
            providerUpdate:true,
        };
        const response = await requestApi.processServerRequest(reqobj);
        const message = response.issuccess 
            ? translateContent("vm.number.delete.succuss")
            : translateContent("vm.number.delete.failed");
        const toastType = response.issuccess ? "success" : "error";
        showToast(message, 'top-right', toastType);
        setShowLoader(false);
        if(response.issuccess){
            backToPN();
        }
    }

    const onInputChange = (e) => {
        let { name, value } = e.target;

        setPnFormData((prevData) => ({
            ...prevData,
            [pnLabelMapper[name]]: value
        }));
    };

    const fetchFormDetails = async () => {
        let reqobj = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "GET_AGENT_DETAILS",
        };
        let response = await requestApi.processServerRequest(reqobj);
        const keysMapping = {
            formid: 'table_250_id',
            agentis: 'Agent_ID',
        };
        const result = {};
        let dropDown = [];
        let fieldNameOutBound = pnLabelMapper['table_250_0_table_250_id'];
        let fieldNameInBound = pnLabelMapper['table_250_1_table_250_id'];
        let defaultAgentoutBound = pnFormData[fieldNameOutBound+"_id"];
        let defaultAgentInBound = pnFormData[fieldNameInBound+"_id"];
        for (const row of response.data) {
            result[row[keysMapping.formid]] = row[keysMapping.agentis];
            let option = {
                value: row['table_250_id'],
                label: row['Agent_Name']
            }
            dropDown.push(option);    
            console.log(option)  ;
            console.log(defaultAgentInBound);
            console.log(row['table_250_id']);
            if( defaultAgentInBound === row['table_250_id']){
                setDefaultDpDownInbound(option)
                setSelectedAgentOutbound(row['Agent_ID']);
            } 
            if(defaultAgentoutBound === row['table_250_id']){
                setDefaultDpDownOutbound(option);
                setSelectedAgentInbound(row['Agent_ID']);
            } 
        }
        setAgentDpDown(dropDown)
        setAgentIds(result);
    };

    // const onSaveBtnClick = () => {
    //     saveBtnRef.current.click();
    // }

    const handleChange = async (option) => {
        let id = option.value;
        setSelectedAgent(agentIds[id]);
        setDefaultDpDown(option);
    }

    const getTitleBody = () => {
        return (
            issubaccountView && 
            (proName.toLocaleLowerCase() === 'vapi' || proName === "retell") && 
            (
                <Button onClick={(e) => { saveMobileDetail(e) }} className="compact-padding theme-bg-g ms-auto" color="light">Save</Button>
            )
        );
    }

    const getTitleContent = () => {
        return(
            isMobile() ? (
                <div className='container-mobile-heading-title me-auto'>
                    <span>
                        <img className='mat-icon' src={back_icon} onClick={(e) => { backToPN(e) }} />
                    </span>
                    {
                        <span>
                            {pnFormData[pnLabelMapper['Name']]} ({pnFormData[pnLabelMapper['Phone_Number']]})
                        </span>
                    }
                </div>
            ) : (
                <div className='container-heading-title me-auto'>
                    <span >
                        <img className='mat-icon' src={back_icon} onClick={(e) => { backToPN(e) }} />
                    </span>
                    {<span>{pnFormData[pnLabelMapper['Name']]} ( {pnFormData[pnLabelMapper['Phone_Number']]} )</span>}
                </div>
            )
        )
    }

    const mainContent = () => {
        return (
            <Container fluid>
                <form id="phone-number-content-form" name={'phonenumber'}>
                    {
                        isMobile() && (
                            <div className='d-flex mt-3 ms-1 me-1'>
                                {
                                    getTitleContent()
                                }
                                {
                                    getTitleBody()
                                }
                            </div>
                        )
                    }
                    <div className='agency-details with-border'>
                        <div className='card-fields d-grid'>
                            <span className="heading" >Icon</span>
                            <span className='cloud-number-logo'>
                                <i class="fi fi-rr-mobile-button"></i>
                            </span>
                        </div>
                        <div className='field-details'>
                            <Row>
                                <Col md={6} className='mt-2'>
                                    <label className={'form-label'} htmlFor="Name">Name</label>
                                    <Controller
                                        name="Name"
                                        control={control}
                                        disabled={false}
                                        rules={{ required: (pnFormData[pnLabelMapper['Name']] === undefined || pnFormData[pnLabelMapper['Name']] === "") ? "Please provide Name" : "" }}
                                        render={({ field }) => (
                                            <Input
                                                {...field}
                                                type="text"
                                                id="Name"
                                                name="Name"
                                                value={pnFormData[pnLabelMapper['Name']] || ''}
                                                onChange={(e) => {
                                                    onInputChange(e);
                                                    field.onChange(e);
                                                }}
                                                className={`form-control ${errors.Name ? 'is-invalid' : ''}`}
                                            />
                                        )}
                                    />
                                    {
                                        errors.Name && <em className='invalid-feedback'>{errors.Name.message}</em>
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6} className='mt-2'>
                                    <label className={'form-label'} htmlFor="Phone_Number">Phone number</label>
                                    <Controller
                                        name="Phone_Number"
                                        control={control}
                                        disabled={true}
                                        rules={{ required: "This field is required" }}
                                        render={({ field }) => (
                                            <Input
                                                {...field}
                                                type="text"
                                                id="Phone_Number"
                                                name="Phone_Number"
                                                value={pnFormData[pnLabelMapper['Phone_Number']] || ''}
                                                onChange={(e) => {
                                                    onInputChange(e);
                                                    field.onChange(e);
                                                }}
                                                className={`form-control ${errors.Phone_Number ? 'is-invalid' : ''}`}
                                            />
                                        )}
                                    />
                                    {
                                        errors.Phone_Number && <em className='invalid-feedback'>{errors.Phone_Number.message}</em>
                                    }
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className='agency-details  with-border'>
                        <div className='card-fields d-grid'>
                            <span className="heading" >AI Agent</span>
                            <span className='header-desc'>Assign agent to phone number</span>
                        </div>
                        <div className='field-details'>
                            <Row>
                                <Col md={6} className='mt-2'>
                                    <label className={'form-label'} htmlFor="brand_name">Outbound call agent</label>
                                    <Controller
                                        name="agent_id_outbound"
                                        control={control}
                                        rules={{ required: (defaultDpDown === undefined || defaultDpDown === "" || defaultDpDown === null) ? "This field is required" : "" }}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                isClearable={true}
                                                onChange={(e) => handleAgentChange(e, "outbound")}
                                                name="agent_id_outbound"
                                                id="agent_id_outbound"
                                                classNamePrefix="sub-select wa-select"
                                                placeholder={"Choose a ai name"}
                                                options={agentDpDown}
                                                value={defaultDpDownOutbound}
                                                menuPlacement="auto"
                                                className={`basic-select ${errors.agent_id_outbound ? 'is-invalid' : ''}`}
                                                isDisabled={!issubaccountView && (proName.toLowerCase() !== 'vapi' ||  proName.toLowerCase() !== 'retell') }
                                            />
                                         )}
                                    />
                                    {
                                        errors.agent_id_outbound && <em className='invalid-feedback'>{errors.agent_id_outbound.message}</em>
                                    } 
                                </Col>
                            </Row>
                        </div>
                        <div className='field-details'>
                            <Row>
                                <Col md={6} className='mt-2'>
                                    <label className={'form-label'} htmlFor="brand_name">Inbound call agent</label>
                                    <Controller
                                        name="agent_id_inbound"
                                        control={control}
                                        rules={{ required: (defaultDpDown === undefined || defaultDpDown === "" || defaultDpDown === null) ? "This field is required" : "" }}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                isClearable={true}
                                                onChange={(e) => handleAgentChange(e, "inbound")}
                                                name="agent_id_inbound"
                                                id="agent_id_inbound"
                                                classNamePrefix="sub-select wa-select"
                                                placeholder={"Choose a ai name"}
                                                options={agentDpDown}
                                                value={defaultDpDownInbound}
                                                menuPlacement="auto"
                                                className={`basic-select ${errors.agent_id_inbound ? 'is-invalid' : ''}`}
                                                isDisabled={!issubaccountView && (proName.toLowerCase() !== 'vapi' ||  proName.toLowerCase() !== 'retell') }
                                            />
                                         )}
                                    />
                                    {
                                        errors.agent_id_inbound && <em className='invalid-feedback'>{errors.agent_id_inbound.message}</em>
                                    } 
                                </Col>
                            </Row>
                        </div>
                    </div>
                    
                    <div className='agency-details  with-border hide'>
                        <div className='card-fields d-grid'>
                            <span className="heading" >Telephony provider</span>
                            <span className='header-desc'>{pnFormData[pnLabelMapper['Provider']]}</span>
                        </div>
                    </div>
                    {
                        issubaccountView && (proName.toLocaleLowerCase() === 'vapi' || proName.toLocaleLowerCase() === 'retell') && (
                            <div className='agency-details'>
                                <div className='card-fields d-grid'>
                                    <span className='heading'>Delete</span>
                                    <span className="header-desc" >Delete your phone number from your account</span>
                                </div>
                                <div className='field-details delete-number'>
                                    <Button className='btn-hover-shine custom-btn-1' onClick={ async (e) => { await removeMobileDetail() } }> 
                                        Delete phone number 
                                    </Button>
                                </div>
                            </div>
                        )
                    }
                    <div className='hide'>
                        <button ref={saveBtnRef} onClick={handleActionFormSubmit((data, event) => saveMobileDetail(event))} className="btn btn-outline-primary">Save & Activate</button>
                    </div>
                </form>
            </Container>
        );
    };
    
    return (
        <Fragment>
            <Common 
                title = {
                    "Phone Numbers"
                }
                titleContent={
                    getTitleContent()
                }
                titleBody={
                    !isMobile() && getTitleBody()
                }
                mainLoader = {
                    showLoader
                }
                mainContent={
                    mainContent()
                } 
            />


        </Fragment>
    )
}

const mapStateToProps = state => ({
    appCustomTitle: state.ThemeOptions.appCustomTitle
});

const mapDispatchToProps = dispatch => ({
    setAppCustomTitle: title => dispatch(setAppCustomTitle(title)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PhoneNumberContent);
